module.exports = ".mat-dialog-content>*{width:500px;margin:0 auto}"